import EFPicture from 'elem/compCommon/EFPicture';
import JoinUsI from 'elem/SVGIcon/OutdoorRecreation/JoinUsVR';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function JoinUs() {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('vanliferoadtrips');
    return (
        <div id="outdoor-recreation-JoinUs" className={`outdoor-recreation-JoinUs ${css['outdoor-recreation-JoinUs']}`}>
            <div className="img-box">
                <EFPicture
                    src="/responsive/picture/vanlife-roadtrips/join_us_1366_au.jpg"
                    srcDesktop="/responsive/picture/vanlife-roadtrips/join_us_1366_au.jpg"
                    srcPad="/responsive/picture/vanlife-roadtrips/join_us_768_au.jpg"
                    srcMobile="/responsive/picture/vanlife-roadtrips/join_us_768_au.jpg"
                    alt={t('secT')}
                />
                <div className="text-content">
                    <JoinUsI />
                    <p className="desc">{t('secT')}</p>
                    <Link
                        className="join-us-btn"
                        href="https://www.facebook.com/groups/efaustralia/"
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'activity_button',
                            page_name: 'vanlife-roadtrips',
                            list_name: 'None',
                            button_name: t('secT_btn'),
                            function: 'Join Community',
                        }}
                    >
                        {t('secT_btn')}
                    </Link>
                </div>
            </div>
        </div>
    );
}
